import { ItemModel } from "./item";

/**  @deprecated models should not ne used anymore */
export class CouvertModel extends ItemModel {}
